// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-bar[data-v-d8ea4e0a]{z-index:20001}.cursor-pointer[data-v-d8ea4e0a]{cursor:pointer}.main-header__element--above[data-v-d8ea4e0a]{position:relative;z-index:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
